import * as Yup from "yup";
import { validatePassword, validateConfirmPassword } from "../common";

export const registrationPasswordSchema = Yup.object().shape({
  password: validatePassword,
  passwordConfirmation: validateConfirmPassword("password"),
});
